import { useQuery } from '@tanstack/react-query'

import { graphql } from '../../schemas/server_admin_query'
import { graphql_multi_call as graphql_admin_multi_call } from '../../schemas/server_admin_query'

export const query_fund_transaction_options = graphql(`
  query query_fund_transaction_options {
    fund_asset_transaction_share_classes
    fund_asset_transaction_spv_share_classes
    fund_asset_transaction_spvs
  }
`)

export type FundTransactionOptionsResponse = {
  fund_asset_transaction_share_classes: string[]
  fund_asset_transaction_spv_share_classes: string[]
  fund_asset_transaction_spvs: string[]
}

export function useFundTransactionOptions() {
  return useQuery({
    queryKey: ['admin', 'fund', 'transaction_options'],
    queryFn: async (): Promise<FundTransactionOptionsResponse | null> => {
      try {
        const response = await graphql_admin_multi_call({
          query: query_fund_transaction_options,
        })

        return response
      } catch (error) {
        console.error('Error fetching fund transaction options:', error)
        return null
      }
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
    gcTime: 15 * 60 * 1000, // 15 minutes
  })
}
